const FlowText = () => {
  return (
    <div className="relative w-full h-fit ">
      <div className="relative w-full h-fit mx-auto flex items-center">
        <div className="relative w-fit min-w-46 h-fit hidden lg:block border-r-2 mr-1">
          <p className="text-lg text-primary">
            <span>실시간&nbsp;견적문의&nbsp;현황&nbsp;&nbsp;</span>
          </p>
        </div>
        <div className="relative w-fit h-fit flow-text">
          <ul className="flex gap-5 flow-wrap text-lg">
            <li>
              <span className="">김00</span> (고독사청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (빈집정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (빈집정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (고독사청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (쓰레기집청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">김00</span> (유품정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (특수청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (빈집정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (쓰레기집청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (점포철거)&nbsp;&nbsp;|
            </li>
          </ul>
          <ul className="flex gap-5 flow-wrap text-lg">
            <li>
              <span className="">김00</span> (유품정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (특수청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (빈집정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (고독사청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (유품정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">김00</span> (특수청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">이00</span> (유품정리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">오00</span> (폐기물처리)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">신00</span> (쓰레기집청소)&nbsp;&nbsp;|
            </li>
            <li>
              <span className="">임00</span> (점포철거)&nbsp;&nbsp;|
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FlowText;
